import React from 'react';
import Head from 'next/head';
import { LegalTermsAccountsContent } from '@components/Shared/LegalPrivacy/LegalAndPrivacy';
import { LegalTermsAccountsStyles } from '@components/Shared/LegalPrivacy/LegalAndPrivacy.styled';

const AccountTermsConditions = () => {
  return (
    <LegalTermsAccountsStyles>
      <Head>
        <title>Terms and Conditions</title>
        <meta
          name="description"
          content="View our Terms and Conditions content"
        />
      </Head>
      <h1>Terms and Conditions</h1>
      <LegalTermsAccountsContent />
    </LegalTermsAccountsStyles>
  );
};

export default AccountTermsConditions;
